var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "ma-4",
          attrs: {
            fab: "",
            color: "primary",
            dark: "",
            fixed: "",
            bottom: "",
            right: "",
            "x-small": "",
          },
          on: {
            click: function ($event) {
              _setup.isChatOpen = true
            },
          },
        },
        [_c("v-icon", [_vm._v("mdi-chat-outline")])],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          attrs: { right: "", temporary: "", width: "400", app: "" },
          model: {
            value: _setup.isChatOpen,
            callback: function ($$v) {
              _setup.isChatOpen = $$v
            },
            expression: "isChatOpen",
          },
        },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", color: "primary", dark: "" } },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "text-subtitle-1 font-weight-bold" },
                [
                  _c("v-icon", [_vm._v("mdi-chat-outline")]),
                  _vm._v(" Assistente Sysclass "),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      _setup.isChatOpen = false
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { ref: "chatContainer", staticClass: "chat-content" },
            [
              _vm._l(_setup.messages, function (msg, index) {
                return _c(
                  "div",
                  { key: index, class: ["chat-row", msg.from] },
                  [
                    _c(
                      "v-avatar",
                      { staticClass: "avatar", attrs: { size: "20" } },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "indigo accent-2" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  msg.from === "bot"
                                    ? "mdi-robot"
                                    : "mdi-account-outline"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "chat-message-wrapper" }, [
                      _c("div", {
                        staticClass:
                          "message-bubble text-body-2 font-weight-regular",
                        domProps: {
                          innerHTML: _vm._s(_setup.renderMarkdown(msg.text)),
                        },
                      }),
                      msg.from === "bot" && index !== 0
                        ? _c(
                            "div",
                            { staticClass: "feedback-buttons mt-1" },
                            [
                              _c("ButtonsReactionIcon", {
                                attrs: {
                                  color:
                                    msg.feedback === "like" ? "green" : "grey",
                                },
                                on: {
                                  clicked: function ($event) {
                                    return _setup.sendFeedback(index, "like")
                                  },
                                },
                              }),
                              _c("ButtonsReactionIcon", {
                                attrs: {
                                  icon: "mdi-thumb-down",
                                  color:
                                    msg.feedback === "dislike" ? "red" : "grey",
                                  tooltip: "A resposta não foi satisfatória",
                                },
                                on: {
                                  clicked: function ($event) {
                                    return _setup.sendFeedback(index, "dislike")
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "timestamp" }, [
                        _vm._v(_vm._s(msg.timestamp)),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "text-center" }, [
                _setup.isLoading
                  ? _c(
                      "span",
                      { staticClass: "text-caption" },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-spin mdi-loading"),
                        ]),
                        _vm._v(" Aguarde... "),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "pa-4" },
            [
              _c("v-textarea", {
                staticClass: "flex-grow-1",
                staticStyle: { "background-color": "white" },
                attrs: {
                  outlined: "",
                  "auto-grow": "",
                  rows: "4",
                  placeholder: "Digite sua mensagem...",
                  "hide-details": "",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    )
                      return null
                    $event.preventDefault()
                    return _setup.sendMessage.apply(null, arguments)
                  },
                },
                model: {
                  value: _setup.newMessage,
                  callback: function ($$v) {
                    _setup.newMessage = $$v
                  },
                  expression: "newMessage",
                },
              }),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    color: "primary",
                    disabled: _setup.newMessage.trim() === "",
                    elevation: "1",
                  },
                  on: { click: _setup.sendMessage },
                },
                [_c("v-icon", [_vm._v("mdi-send")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }